module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', [_c('b-input', {
    directives: [{
      name: "cleave",
      rawName: "v-cleave",
      value: (_vm.masks.creditCard),
      expression: "masks.creditCard"
    }],
    attrs: {
      "placeholder": "Credit Card"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    directives: [{
      name: "cleave",
      rawName: "v-cleave",
      value: (_vm.masks.numeral),
      expression: "masks.numeral"
    }],
    attrs: {
      "placeholder": "Numeral"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "addons": false
    }
  }, [_c('b-input', {
    directives: [{
      name: "cleave",
      rawName: "v-cleave",
      value: (_vm.masks.custom),
      expression: "masks.custom"
    }],
    attrs: {
      "placeholder": "Custom",
      "value": _vm.value
    },
    nativeOn: {
      "input": function($event) {
        return _vm.onInput($event)
      }
    }
  }), _vm._v(" "), _c('p', [_c('b', [_vm._v("Formatted value (v-model)")]), _vm._v(": " + _vm._s(_vm.value))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Raw value")]), _vm._v(": " + _vm._s(_vm.rawValue))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62f8b29c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/extensions/cleavejs/examples/ExFormat.vue
// module id = 1288
// module chunks = 42 53